module.exports = "<app-bar></app-bar>\n<app-header></app-header>\n<app-content></app-content>\n<hr>\n<app-progress></app-progress>\n<hr>{{title}}\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main